import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
export var SHORTENER_PAYLOAD_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ShortenerPayload($id: ID!) {\n    payload(id: $id)\n  }\n"])));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/gql/shortenerPayload.nodecodegen.nographql.js
// module id = 4137
// module chunks = 11